// extracted by mini-css-extract-plugin
module.exports = {"RingLoading":"styles_RingLoading__FPH3E","lds-ring":"styles_lds-ring__k6DYd","RingLoading-black":"styles_RingLoading-black__NPM5_"};